<template>
    <div style="margin: 20px">
        <el-card shadow="never">
            <el-table  
            :data="tableData"
            row-key="id" 
            border
            v-loading="tableLoading"
            :stripe="true">
                <el-table-column prop="payMeterNo" label="表号"></el-table-column>
                <el-table-column prop="oldUseStatus" label="调整前"></el-table-column>
                <el-table-column prop="useStatus" label="调整后"></el-table-column>
                <el-table-column width="100" prop="marginUse" label="差量"></el-table-column>
                <el-table-column width="180" prop="createDate" label="调整日期"></el-table-column>
                <el-table-column width="120" prop="createByStr" label="操作人"></el-table-column>
            </el-table>
            <simple-pagination @search="doSearch" />
        </el-card>
    </div>
</template>

<script>
import '@/assets/scss/common.scss';
import mixin from '@/mixin';
export default {
    name: "ChangePriceRecordTable",
    mixins: [mixin],
    props: {
        meterId: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            queryListUrl: 'meter/web/record/priceDetail',
        }
    },
    methods: {
        getSearchParams() {
            return {
                meterId: this.meterId
            };
        },
        doSearch() {
            this.getList();
        }
    },
    mounted() {
        if(this.meterId) {
            this.doSearch();
        }
    }
}
</script>